import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { ROADMAP, ROADMAP_INTRO } from "@/data/content";
import { useT } from "@/i18n/LanguageContext";

export const Roadmap = () => {
  const t = useT();
  const timelineRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: timelineRef,
    offset: ["start 80%", "end 60%"],
  });

  return (
    <section id="roadmap" data-testid="roadmap-section" className="relative py-24 lg:py-32 wf-mesh">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="uppercase text-xs tracking-[0.25em] text-[#1A1A1F] font-bold">
            {t(ROADMAP_INTRO.eyebrow)}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-4">
            {t(ROADMAP_INTRO.title)}
          </h2>
        </div>

        <div ref={timelineRef} data-testid="roadmap-timeline" className="relative mt-16">
          <div className="absolute left-4 sm:left-1/2 top-0 bottom-0 w-px bg-[#23262E]" />
          <motion.div
            style={{ scaleY: scrollYProgress }}
            className="absolute left-4 sm:left-1/2 top-0 bottom-0 w-px origin-top bg-gradient-to-b from-white via-[#C9CDD6] to-[#8A8F9C]"
          />

          {ROADMAP.map((phase, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              data-testid={`roadmap-phase-${i}`}
              className={`relative flex mb-12 last:mb-0 pl-12 sm:pl-0 ${
                i % 2 === 0 ? "sm:justify-start" : "sm:justify-end"
              }`}
            >
              <span className="wf-pulse-dot absolute left-4 sm:left-1/2 -translate-x-1/2 top-2 w-4 h-4 rounded-full bg-[#0A0A0F] ring-4 ring-[#0A0A0F]/15" />
              <div className="w-full sm:w-[calc(50%-3rem)] p-8 rounded-3xl bg-white border border-[#E8E7E2] hover:border-[#0A0A0F]/25 transition-colors duration-300">
                <span className="uppercase text-xs tracking-[0.2em] text-[#1A1A1F] font-bold">
                  {t(phase.phase)}
                </span>
                <h3 className="font-heading text-xl font-medium mt-2">{t(phase.title)}</h3>
                <ul className="mt-4 space-y-2">
                  {phase.items.map((item, idx) => (
                    <li key={idx} className="text-sm text-[#62646B] leading-relaxed flex gap-2">
                      <span className="text-[#0A0A0F] mt-0.5">▸</span>
                      {t(item)}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
